import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import { Link } from "react-router-dom";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import RunReportNow from "../RunReportNow";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import errorimages from "../Asset/download1.png"
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import Loader from "../CommonLoader";
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import { datezonechange } from "./../Commonfun"
import CommonAlert from "../../../Commonalert/commonalert";
import Select from 'react-select';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';




export default function AccessibilityList() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [jobidValue, setjobValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [Domainsectiondata, SetDomainsectiondata] = useState([])
  const esodata = useSelector((state) => state);
  const [autoheightval, SetAutoheightval] = useState(true)
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [accessibilityReportPlan, setaccessibilityReportPlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const navigate = useNavigate();

  const ApiToken = esodata.apiauthkey.value
  let result = ApiToken.split(" ");

  let detailurl = `${process.env.REACT_APP_DOMAIN}accessibility-report-detail/`;

  const isTabletView = window.innerWidth <= 768;


  const apihandleClose = () => {
    setapiOpen(false);
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));


  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>
  );



  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=54`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const checkUserPlan = async () => {
    const accessibilityReportP = await Utils("accessibility_report", ApiToken);
    if (accessibilityReportP.status) {
      callUserdataApi();
      GetFilterOptions();
      faqdatafun()
    }
    setaccessibilityReportPlan(accessibilityReportP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };

  const columns = [

    // {
    //   field: "sid",
    //   headerName: "#",
    //   minWidth: 100,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   headerAlign: "center",
    //   align: "center",

    // },

    {
      field: "link__url",
      headerName: "URL",
      description: "URL of the web page",
      minWidth: 320,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {

        let baseUrl = cardData.row.link__url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.link__url.split("/").slice(3).join("/");

        return (
          <>

            <Tooltip title={cardData.row.link__url}>
              <div className="prefered_url_external02">
                <a className="table_links" target="_blank" href={cardData.row.link__url} style={{ display: 'flex', flexDirection: 'column' }} >
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>

            </Tooltip>
          </>
        );
      },

    },

    {
      field: "forms",
      headerName: "Forms",
      description: "Form Count",
      minWidth: 110,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      disableClickEventBubbling: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.forms;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.forms
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "menus",
      headerName: "Menus",
      description: "Menus Count",
      minWidth: 110,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.menus;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.menus;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "tables",
      headerName: "Tables",
      description: "Tables Count",
      minWidth: 110,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.tables;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.tables;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "titles",
      headerName: "Titles",
      description: "Title Count",
      minWidth: 110,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.titles;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.titles;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "general",
      headerName: "General",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      description: "General Count",
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.general;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.general;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "document",
      headerName: "Document",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Document Count",
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.document;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.document;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "graphics",
      headerName: "Graphics",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      description: "Graphics Count",
      valueGetter: (params) => {
        const value = params?.row?.table_data?.graphics;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.graphics;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "carousels",
      headerName: "Carousels",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Carousels Count",
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.carousels;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.carousels;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "clickables",
      headerName: "Clickables",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      description: "Clickables Count",
      valueGetter: (params) => {
        const value = params?.row?.table_data?.clickables;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.clickables;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "orientation",
      headerName: "Orientation",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Orientation Count",
      disableClickEventBubbling: true,
      sortable: true,
      valueGetter: (params) => {
        const value = params?.row?.table_data?.orientation;
        return value || 0;
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.orientation;
        return value !== null && value !== undefined ? `${value}%` : '-';
      },

    },
    {
      field: "readability",
      headerName: "Readability",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      disableClickEventBubbling: true,
      sortable: true,
      description: "Readability Count",
      valueGetter: (params) => {
        const value = params?.row?.table_data?.readability;
        return value || 0; // ensure numeric value for sorting
      },
      renderCell: (cardData) => {
        const value = cardData?.row?.table_data?.readability;
        const data = value ? `${value}%` : '-';
        return (
          <div>{data}</div>
        )
      },

    },

    {
      field: "view",
      headerName: "View",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      headerClassName: 'hide_option',
      renderCell: (cardData) => {


        return (
          <a href={detailurl + `${cardData.row.id}` + "/" + jobidValue}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    },

  ];

  const rows = cardData ?? [];

  const callUserdataApi = async (jobid = "", SelectedWcagType = "", domainsecdata = "") => {
    setLoading(true);
    setTableLoading(true);
    if (domainsecdata == "")
      domainsecdata = Domainsectiondata;

    setCardData([])
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/accessibility2_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      const dataval = datavalue?.data?.table_data;
      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))

      if (dataval && dataval.length > 0) {
        SetAutoheightval(false)

        const newData = dataval.map((obj, index) => {

          return { ...obj, sid: index + 1 };
        });

        setCardData(newData);

        setjobValue(datavalue?.data?.job_id)
      }
      else {
        setCardData("")
        SetAutoheightval(true)
      }
    }
    catch (err) {
      console.log('err', err)
    }

    setTableLoading(false);
    setLoading(false);
  };

  const reportNow = async () => {

    var errs = 1;
    let errors = {};
    if (!dEngineoption || dEngineoption.id == "") {
      // if (selectval == "" || SelectedWcagType == '') {
      errors.dateerror = "All Fields are required.";
      errs = 2;
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }

    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    setLoading(true);


    var domainsec = "";
    callUserdataApi("", SelectedWcagType, domainsec = "")

  };
  function openModal() {
    if (accessibilityReportPlan.status) {
      setfaqData(2)
      setIsOpen(true);
    }
  }
  function closeModal() {
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);


  }

  const [WcagType, SetWcagType] = useState([])
  const [SelectedWcagType, SetSelectedWcagType] = useState('AA')
  const [DefaultSelectedWcagType, SetDefaultSelectedWcagType] = useState([])
  const GetFilterOptions = async () => {
    setcompletedate([])
    try {
      const FetchList = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=accessibility2`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (FetchList.data) {
        // var Selectedmets = [];
        if (FetchList?.data?.jobs.length > 0) {
          // FetchList?.data?.jobs.forEach((element) => {
          //   Selectedmets.push({ value: element?.id, label: datezonechange(element?.completed_at) });
          // });
          const uniqueByCompletedAt = removeDuplicateDate(FetchList?.data?.jobs);
          setSelectval(uniqueByCompletedAt[0]?.value);
          SetdEngineoption(uniqueByCompletedAt[0]);
          setprevdEngineoption(uniqueByCompletedAt[0]);
          setcompletedate(uniqueByCompletedAt);
        }
      }

      var WcagTypeArray = [];
      WcagTypeArray.push({ label: 'A', value: 'A' })
      WcagTypeArray.push({ label: 'AA', value: 'AA' })
      WcagTypeArray.push({ label: 'AAA', value: 'AAA' })

      SetWcagType(WcagTypeArray)
      SetDefaultSelectedWcagType(WcagTypeArray[1])

    } catch (err) {
      console.log('err', err)
    }

  }

  const OnsetSelectval = (values) => {
    setSelectval(values.value)

  }
  const OnSetSelectedWcagType = (values) => {
    SetDefaultSelectedWcagType(values[0])
    SetSelectedWcagType(values[0]?.value)
    var domainsec = "";
    callUserdataApi("", values[0]?.value, domainsec = "")
  }
  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('accessibility2')

  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/accessibility2_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("AccessibilityreportList", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/accessibility2_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("AccessibilityreportList", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const SetSectionNameHandle = (passvalue) => {
    SetDomainsectiondata(passvalue[0].value)
    callUserdataApi("", '', passvalue[0].value);
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  function handleReset() {
    SetdEngineoption("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }


  return (

    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Accessibility Report</title>
      </Helmet>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Accessibility Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'Accessibility & Complaince' },
                      { title: 'Accessibility Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => {
                    if (first.statusDomain) {
                      setcheckD(first.statusDomain);
                    } else {
                      SetRunReportPopShow(true)
                    }
                  }}

                  disabled={!accessibilityReportPlan.status}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <Link to="/accessibility-score" >
                    <button type="button"
                      className={`trendy-tab`}  >Accessibility Score</button>
                  </Link>
                  <Link to="/accessibility-summary" >
                    <button type="button"
                      className={`trendy-tab`}  >Summary</button>
                  </Link>
                    <Link to="/color-checker" >
                      <button type="button"
                        className={`trendy-tab`}  >Color Contrast Checker</button>
                    </Link>
                  <Link to="/accessibility-report" >
                    <button type="button"
                      className={`trendy-tab active`}  >Report</button>
                  </Link>
                  <Link to="/accessibility-file" >
                    <button type="button"
                      className={`trendy-tab`}  >File Accessibility</button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              {accessibilityReportPlan.status &&
                <div class="row pie_chart_row acc-rpt-list" style={{ "margin-top": "inherit", textAlign: "center" }}>
                  {cardData.length > 0 ?
                    <img src={`${process.env.REACT_APP_API_URL}technical/accessibility2_image/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&token=${result[1]}`} style={{ width: "500px", height: "300px", alignItems: "center", marginLeft: "300px" }} /> : <img src={errorimages} alt="errimg" title="Errorimage" style={{ width: "500px", height: "300px", alignItems: "center", marginLeft: "300px" }} />}
                </div>
              }
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {accessibilityReportPlan.status ?
                  <div>

                    <div className="data_table internal_source_table internal_outsource_table" style={{ width: "100%" }}>
                      <div style={{ height: rows.length > 5 ? 550 : 'unset', width: "100%" }} className="over_all_accessibility analysissummary_table">
                        <DatagridComp
                          columns={columns}
                          rows={rows}
                          autoheightval={autoheightval}
                          datagridval={2}
                          columnFreezeWidth={[0, 320]}
                          tableLoading={tableLoading}
                          handleModelPopUp={handleModelPopUp}
                          handleDownlodingCSV={handleDownlodingCSV}
                          handleDownlodingPDF={handleDownlodingPDF}
                          customFilter={true}
                          DownloadShowFile={true}
                          DownloadShowPDF={1}
                          DownloadShowCSV={2}
                        />
                      </div>
                    </div>
                  </div> : <Freeaudit planStatus={accessibilityReportPlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

      <div className="cnt_audit_outer_wrap">
        {/* <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Accessibility Report', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />
            </button>
            {accessibilityReportPlan.status &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading} csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Accessibility Report</h2>
              <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={openModal} />
              </span>
            </div>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
          <div className="cnt_hdr_top_rgt_wrap">
            <button
              title="Run Report"
              className="runreportnew over_all_accessibility runreportnew"
              onClick={() => {
                if (first.statusDomain) {
                  setcheckD(first.statusDomain);
                } else {
                  SetRunReportPopShow(true)
                }
              }}

              disabled={!accessibilityReportPlan.status}
            >
              Run Report Now
            </button>
          </div>
        </div>
        <div className="center_tab accessbility_button_tap ">
          <Link to="/accessibility-score" ><button type="button" className={`runreportnews`}  >Accessibility Score</button></Link>
          
          <Link to="/accessibility-summary" ><button type="button" className={`runreportnews `}  >Summary</button></Link>
          <Link to="/accessibility-report" ><button type="button" className={`runreportnews active`}  >Report</button></Link>
          <Link to="/accessibility-file" ><button type="button" className={`runreportnews `}  >File Accessibility</button></Link>
        </div>

        {accessibilityReportPlan.status ?
          <div>
            <div class="row pie_chart_row acc-rpt-list" style={{ "margin-top": "inherit" }}>
              {cardData.length > 0 ?
                <img src={`${process.env.REACT_APP_API_URL}technical/accessibility2_image/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&token=${result[1]}`} style={{ width: "500px", height: "300px", alignItems: "center", marginLeft: "300px" }} /> : <img src={errorimages} alt="errimg" title="Errorimage" style={{ width: "500px", height: "300px", alignItems: "center", marginLeft: "300px" }} />}
            </div>

            <div className="data_table internal_source_table internal_outsource_table" style={{ width: "100%" }}>
              <div style={{ height: rows.length > 5 ? 550 : 'unset', width: "100%" }} className="over_all_accessibility analysissummary_table">
                <DatagridComp
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 320]}
                  tableLoading={tableLoading}
                />
              </div>
            </div>
          </div> : <Freeaudit planStatus={accessibilityReportPlan} />
        } */}




        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter"
        >
          <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">

                <div>

                  <div className="" style={{ marginBottom: '10px' }}>
                    <div>
                      <span>Completed Date</span>
                      <Select
                        value={dEngineoption}
                        options={completedate}
                        placeholder="Select..."
                        labelField="completed_at"
                        valueField="id"
                        onChange={(values) => {
                          OnsetSelectval(values)
                          SetdEngineoption(values);
                        }}
                        styles={customDropdownStyles()}
                        menuPortalTarget={document.body}
                      />
                    </div>


                  </div>

                  <span className="text-error">{validation.dateerror}</span>



                </div>

              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button className="form_submit_btn" onClick={reportNow} style={{ cursor: 'pointer' }} >
              Submit
            </button>
            <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
            <button
              className="form_submit_btn"
              style={{ cursor: "pointer" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </DialogActions>
        </Dialog>

        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

        {!openCommonAlerts && <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className="keyword-dialog-header">{"Error Message "}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              No Data Found
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>}
        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Please verify your domain to access these features
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
            <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      </div>
      <RunReportNow RunReportPopShow={RunReportPopShow} SetRunReportPopShow={SetRunReportPopShow} RunReportType={RunReportType} />
    </div>
  );
}
